/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Vue, Watch } from 'vue-property-decorator'
import { UserModule } from '@/store/modules/user'
import { gettHeaderByType, settHeaderByType, getCustmerListById } from '@/api/common'
import { delNullProperty } from '@/utils/index'
import { menuBtn } from '@/utils/menu_level2_button'
import realTimeSokcet from '@/utils/socket.io'
import { Loading } from 'element-ui';
import commonData from "@/utils/commonData";

@Component({})
export default class SchoolDetail extends Vue {
    socket: any = null
    tableHeadPopoverShow = false
    tableData: any = []
    checkTableRow: any = []
    tableHeadFilter = {
        souCourseName: '',
        grade: '',
        caseStatus: '',
        souCourseType:'',
        specialized:''
    }
    page = 1
    limit = 20
    total = 0
    selfTotal = 0
    loading = false
    gradeList = [
        '美制7年级/英制8年级/初一（普高）',
        '美制8年级/英制9年级/初二（普高）',
        '美制9年级/英制10年级/初三（普高）',
        '美制10年级/英制11年级/高一（普高）',
        '美制11年级/英制12年级/高二（普高）',
        '美制12年级/英制13年级/高三（普高）',
        '大学一年级',
        '大学二年级',
        '大学三年级',
        '大学四年级',
        '研究生及以上',
        '已毕业',
        '待定'
    ]
    typeList= commonData.projectTypeArray
    menuBtn = menuBtn
    // computed
    get userId() {
        return UserModule.userId
    }

    // created
    created() {
        this.getTableData()
    }

    // updated(){
    //     this.$nextTick(() => {
    //         this.initSocket()
    //     })
    // }

    destroyed() {
        // this.socket.disconnect()
    }

    // methods
    // async getTableHeader() {
    //     this.loading = true
    //     const data: any = await gettHeaderByType(3)
    //     this.tableHeader = data.headerUserList
    //     this.loading = false
    //     this.getTableData()
    // }
    async getTableData() {
        this.loading = true
        const obj = { ...this.tableHeadFilter, page: this.page, limit: this.limit, id: Number(this.$route.query.id) }
        const data: any = await getCustmerListById(delNullProperty(obj))
        this.tableData = data.customerList
        this.total = data.allNum
        this.loading = false
    }

    pageChange(page: number) {
        this.page = page
        this.getTableData()
    }
    pageSizeChange(limit: number) {
        this.limit = limit
        this.getTableData()
    }
    removePropertyOfNull(object: any) {
        const obj = JSON.parse(JSON.stringify(object))
        Object.keys(obj).forEach(item => {
            if ((obj[item] === '' || !obj[item] || obj[item].length === 0) && obj[item] !== 0) {
                delete obj[item]
            }
        })
        return obj;
    }
    initSocket() {
        const time = setInterval(() => {
            if(Vue.prototype.$socket.on) {
                realTimeSokcet(this.userId, 'MarketClue', this.getTableData)
                clearInterval(time)
            }
        }, 100)
    }

    @Watch('userId')
    handleWatchUserId() {
        this.initSocket()
    }
}
